import { render, staticRenderFns } from "./IQubeSVGWithFoot.vue?vue&type=template&id=39c21ef0"
import script from "./IQubeSVGWithFoot.vue?vue&type=script&lang=ts"
export * from "./IQubeSVGWithFoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports